<div class="patient-switch-container" #patientInfoTarget>
    <p-dropdown
        id="dd-patient"
        [placeholder]="placeholder"
        class="w-12"
        [options]="patients"
        dataKey="patientId"
        [(ngModel)]="selectedPatient"
        (onChange)="onPatientSelect($event.value)"
        (onClick)="basicinfo.hide($event)"
        [showClear]="!isReadOnly()"
        [filter]="true"
        [filterFields]="['fullName','miProNumber', 'externalPatientId']"
        appendTo="body"
        [virtualScroll]="false"
        [readonly]="isReadOnly()">

        <ng-template pTemplate="selectedItem">
            <div class="patient-item patient-item-value flex align-items-start justify-content-start" *ngIf="selectedPatient">
                <div (mouseover)="basicinfo.show($event, patientInfoTarget); showLockInfo($event, patientInfoTarget)">
                    <p-progressSpinner *ngIf="loadingPatientAvatar"></p-progressSpinner>
                    <img
                        *ngIf="!loadingPatientAvatar"
                        class="border-circle"
                        [src]="patientAvatarUrl"
                        onerror="'assets/images/noavatar.png'" />
                    <div>
                        <span>
                            <naming-convention-label [type]="'EndUser'" [singular]="true"></naming-convention-label>
                        </span>
                        <span class="patient-name">{{ selectedPatient.fullName }}</span>
                    </div>
                </div>
            </div>
        </ng-template>
        <ng-template let-patient pTemplate="item">
            <span>{{ patient.fullName }}</span>
        </ng-template>
        <ng-template pTemplate="header">
            <div class="flex justify-content-end p-3 pb-0" *ngIf="canCreatePatient">
                <a (click)="showAddPatientDialog = true" class="add-patient-btn">
                    <i class="pi pi-plus pr-1"></i>
                    <span>Add</span>
                </a>
            </div>
        </ng-template>
    </p-dropdown>
</div>

<p-overlayPanel #lockInfo [appendTo]="'body'"  styleClass="lock-info-overlay">
    <div>Please complete your updates and save before changing patient </div>
</p-overlayPanel>



<p-overlayPanel #basicinfo>
    <ng-template pTemplate>
        <table width="250px">
            <tr>
                <td><b>ORB Number:</b></td>
                <td>{{ selectedPatientInfo.miProNumber }}</td>
            </tr>
            <tr *ngIf="selectedPatientInfo.externalId">
                <td><b>External ID:</b></td>
                <td>{{ selectedPatientInfo.externalId }}</td>
            </tr>
            <tr>
                <td><b>Date of Birth:</b></td>
                <td>{{ selectedPatientInfo.dateOfBirth?.toLocaleDateString("en-GB") }}</td>
            </tr>
            <tr>
                <td><b>Address:</b></td>
                <td>{{ selectedPatientInfo.address }}</td>
            </tr>
            <tr>
                <td><b>Phone No:</b></td>
                <td>{{ selectedPatientInfo.phoneNumber }}</td>
            </tr>
            <tr>
                <td>
                    <b><naming-convention-label [type]="'Group'" [singular]="true"></naming-convention-label></b>
                </td>
                <td>{{ selectedPatientInfo.squadName }}</td>
            </tr>
            <tr>
                <td><b>User Type:</b></td>
                <td>{{ selectedPatientInfo.userType }}</td>
            </tr>
        </table>
    </ng-template>
</p-overlayPanel>

<create-player-dialog
    doNotPropagateClick
    (playerCreated)="onPlayerCreate($event)"
    [(visible)]="showAddPatientDialog"></create-player-dialog>

<p-dialog
    id="patient-selector-dialog"
    [header]="dialogHeader"
    [visible]="showDialog"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    [resizable]="false">
    <div class="inputs-group">
        <div class="inputs-group-row">
            <p-dropdown
                id="dd-patient-dialog"
                class="w-12"
                (onClick)="basicinfo.hide($event)"
                [showClear]="!isClinicalSafetyOfficer"
                [readonly]="isClinicalSafetyOfficer"
                [options]="patients"
                [dataKey]="offline && selectedPatient?.id ? 'id' : 'patientId'"
                [(ngModel)]="selectedPatient"
                optionLabel="fullName"
                placeholder="Select"
                appendTo="body"
                (onChange)="onPatientSelect($event.value)"
                [filter]="true"
                filterBy="fullName"
                [virtualScroll]="false">
                <ng-template pTemplate="header">
                    <div
                        class="filter-header"
                        *ngIf="canCreatePatient"
                        style="display: flex; justify-content: flex-end; padding: 10.5px 14px 0px 10.5px">
                        <a (click)="showAddPatientDialog = true">
                            <i class="pi pi-plus" style="cursor: pointer"></i>
                            <span style="cursor: pointer">Add</span>
                        </a>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
    </div>

    <form-buttons allowOffline [disabled]="!selectedPatient" [config]="buttonsConfig"></form-buttons>
</p-dialog>
